export default __webpack_public_path__ + "static/media/Group-7.0a2337dd.png";